
        var result = require("!!../../../../node_modules/css-loader/index.js!./parse-tickets.component.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/manage/parse-tickets/parse-tickets.component.css
// module id = 728
// module chunks = 0